interface FormatIconProps {
  width?: string;
  height?: string;
  stroke?: string;
  className?: string;
  onClick?: () => void;
}

/** Curly-braces glyph used for the "Format / pretty-print JSON" action. */
const FormatIcon = (props: FormatIconProps) => {
  const stroke = props.stroke || "#0056D6";
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      onClick={props.onClick}
    >
      <path
        d="M6.5 2.5C5.5 2.5 5 3 5 4V6C5 7 4.5 7.5 3.5 8C4.5 8.5 5 9 5 10V12C5 13 5.5 13.5 6.5 13.5"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 2.5C10.5 2.5 11 3 11 4V6C11 7 11.5 7.5 12.5 8C11.5 8.5 11 9 11 10V12C11 13 10.5 13.5 9.5 13.5"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FormatIcon;
